export class LocalStorageHelper {
  public static readonly isStorageAvailable = (): boolean => {
    try {
      if (typeof window === "undefined") {
        return false;
      }

      localStorage.setItem("test", "test");
      if (localStorage.getItem("test") !== "test") {
        throw new Error("localStorage not available");
      }
      localStorage.removeItem("test");
      return true;
    } catch (e) {
      console.warn("localStorage not available:", e instanceof Error ? e.message : e);
      return false;
    }
  };

  public static readonly isCacheExpired = (key: string, expirationInHours: number): boolean => {
    if (typeof window === "undefined") {
      return true;
    }

    const fetchedOnTimestamp = parseInt(localStorage.getItem(key) ?? "", 10);
    if (Number.isNaN(fetchedOnTimestamp)) return true;

    const currentTimestamp = Date.now();
    const diffInMilliseconds = currentTimestamp - fetchedOnTimestamp;
    const diffInHours = diffInMilliseconds / (1000 * 60 * 60);

    return diffInHours >= expirationInHours;
  };
}
